import { createRouter, createWebHashHistory } from "vue-router";
import ExhibitView from "@/views/Exhibit.vue";
import AuthorView from "@/views/Author.vue";
import ExhibitList from "@/views/ExhibitList.vue";
import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/exhibitList",
    name: "ExhibitList",
    component: ExhibitList,
  },
  {
    path: "/exhibit",
    name: "Exhibit",
    component: ExhibitView,
  },
  {
    path: "/author",
    name: "Author",
    component: AuthorView,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
